export default {
    navigationBarTitleText: intl.get('home.title'),
    navigationBarBackgroundColor:"#DF773C",
  };
